/* unplugin-vue-components disabled */import script from "./share-option.vue?vue&type=script&setup=true&lang=js"
export * from "./share-option.vue?vue&type=script&setup=true&lang=js"

import "./share-option.vue?vue&type=style&index=0&id=26bd2917&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26bd2917"]])

export default __exports__